import React, { useEffect } from 'react'
import { getShow, getPageIsFullyLoaded } from 'redux/slices/liveShow'
import { retrieveLiveData, setPageLeave, refreshUserAccessState } from 'redux/slices/liveShow/thunks'
import { useParams } from 'react-router-dom'
import AnimatedSetPageLoading from 'components/set/AnimatedSetPageLoading/AnimatedSetPageLoading'
import { Helmet } from 'react-helmet'
import { connect, useDispatch } from 'react-redux'
import { isNil } from 'lodash'
import ReactPixel from 'react-facebook-pixel'
import { showError } from 'redux/slices/globalError'
import ReactGA from 'react-ga'
import { bindActionCreators } from 'redux'
import Event from 'components/set/Event/Event'
import { useAuthenticatedState } from 'libs/web-client/utils/auth0/src'

const SetPage = ({ show, pageIsFullyLoaded, showErrorModal }) => {
    const { showPath } = useParams()
    const dispatch = useDispatch()
    const { isAuthenticated } = useAuthenticatedState()

    useEffect(() => {
        const promise = dispatch(retrieveLiveData(showPath))
        return () => {
            promise.abort()
            dispatch(setPageLeave())
        }
    }, [dispatch, showPath])

    useEffect(() => {
        dispatch(refreshUserAccessState())
    }, [dispatch, isAuthenticated, show])

    useEffect(() => {
        if (show && show.trackingIds) {
            if (show.trackingIds.facebookPixelId) {
                ReactPixel.init(show.trackingIds.facebookPixelId, undefined, { autoConfig: true, debug: false })
                ReactPixel.pageView()
            }
            if (show.trackingIds.googleTagId) {
                ReactGA.initialize(show.trackingIds.googleTagId)
                ReactGA.pageview(window.location.pathname + window.location.search)
            }
        }
    })

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (!pageIsFullyLoaded) {
                showErrorModal(`We're experiencing some connectivity issues. Please refresh the page to try again`)
            }
        }, 10000)
        return () => {
            clearTimeout(timeoutId)
        }
    }, [pageIsFullyLoaded, showErrorModal])

    return (
        <>
            <Helmet>
                <title>{`${isNil(show) ? 'Novel' : show.artist.name} Livestream`}</title>
                {/*Google Chromecast*/}
                <script
                    type="text/javascript"
                    src="https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1"
                ></script>
            </Helmet>

            <AnimatedSetPageLoading show={show} isLoading={!pageIsFullyLoaded} />

            {pageIsFullyLoaded && show && <Event show={show} />}
        </>
    )
}
const mapStateToProps = state => ({
    show: getShow(state),
    pageIsFullyLoaded: getPageIsFullyLoaded(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({ showErrorModal: showError }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(SetPage))
